import { TAB_CLASS_NAME } from "Common/componentUtils/constants";
import includes from "lodash/includes";
import styled from "styled-components";
export const SIZES = {
    SLIDER_HEIGHT: "2px",
    TAB_PADDINGS: "7px 0 8px",
    GAP: "16px"
};
export default {
    ReactTabs: styled.div
        .withConfig({
        shouldForwardProp: (prop) => !includes(["rightPanelWidth"], prop)
    })
        .attrs({
        className: "position-relative"
    }) `
    display: grid;
    grid-auto-flow: column dense;
    justify-content: start;
    ${({ rightPanelWidth }) => (rightPanelWidth ? `width: calc(100% - ${rightPanelWidth}px);` : "")}

    .${TAB_CLASS_NAME} {
      flex-shrink: 2;
      flex-grow: 0;
      color: ${({ theme }) => theme["M3-sys-light-on-surface-variant"]};
      user-select: none;
      padding: ${SIZES.TAB_PADDINGS};
      margin: 0 1em;
        
      &:hover {
        color: ${({ theme }) => theme["M3-sys-light-on-surface"]};
        text-decoration: none;
      }
        &.active{
            color: ${({ theme }) => theme["M3-sys-light-on-surface"]} !important;
            font-weight: 600;
        }
    }
  `,
    Slider: styled.div `
    position: absolute;
    bottom: -1px;
    height: ${SIZES.SLIDER_HEIGHT};
    // border-radius: ${SIZES.SLIDER_HEIGHT};
    background-color: ${({ theme }) => theme["brand-primary-500"]};
    transition:
      width linear 0.2s,
      left linear 0.2s;
  `
};
